import { Button, Classes, H3, H6, Intent, Overlay } from "@blueprintjs/core";
import classNames from "classnames";
import * as React from "react";
import { ERROR_TOAST_ICON } from "../../../utils/Constants";
import { getDrivers, getProviders } from '../../services/providerApiService';
import { confirmProvider } from '../../services/tripApiService';
import {
	confirmProviderSaveButton, displayFlex, driverPadding, labelContainer, labelDriver, overlayConfirmProviderContainer,
	overlayFooterConfirmProvider, providerContainer, requiredColor
} from '../../styles';
import { AppToaster } from "../../toastComponent";
import DriverDropdown from "../dropdownComponents/driverDropdown";
import ProviderDropdown from '../dropdownComponents/providerDropdown';


const OVERLAY_EXAMPLE_CLASS = "docs-overlay-example-transition";
const OVERLAY_TALL_CLASS = "docs-overlay-example-tall";


class OverlayConfirmProvider extends React.PureComponent {

	constructor(props) {
		super(props)

		this.state.trip = props.trip;
		this.state.isSelectNewDriver = props.isSelectNewDriver
	}

	state = {
		isLoading: false,
		autoFocus: true,
		canEscapeKeyClose: true,
		canOutsideClickClose: false,
		enforceFocus: true,
		isOpen: true,
		usePortal: true,
		providers: [],
		drivers: [],
		trip: null,
		isSelectNewDriver: false,
		selectedProvider: null,
		selectedDriver: null,
		isConfirmDisabled: true,
		disableProviderDropdown: false,
	};

	componentDidMount = async () => {
		await this.getProviders();

		if (this.state.isSelectNewDriver) {
			this.getDrivers(this.state.selectedProvider)
		}
	}

	getProviders = async () => {
		try {
			const top = 1000;
			const providers = await getProviders({ top: top, isEligible: true });

			if (this.state.isSelectNewDriver) {
				const selectedProvider = providers.find(provider => provider.providerId === this.state.trip.serviceProviderId);

				await this.setState({
					providers: providers,
					selectedProvider: selectedProvider,
					disableProviderDropdown: true,
				})
			} else {
				this.setState({
					providers: providers,
				})
			}
		}
		catch (error) {
			console.log(error);
		}
	}

	getDrivers = async (provider) => {
		try {
			const top = 1000;
			const drivers = await getDrivers(provider.providerId, { top: top, isEligible: true });

			await this.setState({
				drivers: drivers,
			});
		} catch (error) {
			console.log(error);
			await this.setState({
				drivers: []
			});
		}
	}

	handleConfirm = async () => {
		if (this.state.selectedDriver == null || this.state.selectedProvider == null) {
			AppToaster.show({ message: "* Complete mandatory fields.", intent: "danger", icon: ERROR_TOAST_ICON, });
			return;
		}

		try {
			this.setState({
				isLoading: true,
			})

			const message = this.state.isSelectNewDriver ? 'Driver confirmed.' : 'Provider confirmed.';

			await confirmProvider(this.props.trip.tripNumber, this.state.selectedDriver.driverId, this.props.trip.pickupTimeZone);
			AppToaster.show({ message: message, intent: "success", icon: 'tick', });

		}
		catch (error) {
			console.log(error);
			AppToaster.show({ message: error.response.data, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
		}
		finally {
			this.handleClose();
		}
	}

	handleProviderChange = (event) => {
		const provider = event.provider
		this.getDrivers(provider);

		this.setState({
			selectedProvider: provider,
			selectedDriver: null,
		});
	}

	handleDriverChange = (event) => {
		const driver = event.driver;
		this.setState({
			selectedDriver: driver,
			isConfirmDisabled: false
		})
	}


	render() {
		const classes = classNames(
			Classes.CARD,
			Classes.ELEVATION_4,
			OVERLAY_EXAMPLE_CLASS,
			localStorage.getItem("themeName"),
			{ [OVERLAY_TALL_CLASS]: this.state.useTallContent },
		);

		return (
			<Overlay className={Classes.OVERLAY_SCROLL_CONTAINER} transitionName={Classes.OVERLAY} onClose={this.handleClose} {...this.state}>
				<div className={classes} style={overlayConfirmProviderContainer}>
					{this.state.isSelectNewDriver ? (<H3>Confirm New Driver</H3>) : (<H3>Confirm Provider</H3>)}
					<div>
						<label style={labelContainer}>
							<div style={providerContainer}>
								<H6><strong>Select the Provider</strong></H6>
								<H3 style={requiredColor}>*</H3>
							</div>
							<ProviderDropdown
								isMulti={false}
								isClearable={false}
								providers={this.state.providers}
								selectedProvider={this.state.selectedProvider}
								disabled={this.state.disableProviderDropdown}
								handleProviderChange={this.handleProviderChange}
							/>
						</label>
					</div>
					<div style={driverPadding}>
						<label style={labelDriver}>
							<div style={displayFlex}>
								<H6><strong>Select the Driver </strong></H6>
								<H3 style={requiredColor}>*</H3>
							</div>
							<DriverDropdown
								drivers={this.state.drivers}
								selectedDriver={this.state.selectedDriver}
								handleDriverChange={this.handleDriverChange}
							/>
						</label>
					</div>
					<br />
					<div className={Classes.OVERLAY_FOOTER_ACTIONS} style={overlayFooterConfirmProvider}>
						<Button intent={Intent.SUCCESS} style={confirmProviderSaveButton} onClick={this.handleConfirm} text="Confirm" loading={this.state.isLoading} />
						<Button intent={Intent.NONE} onClick={this.handleClose} text="Cancel" disabled={this.state.isLoading} />
					</div>
				</div>
			</Overlay>
		);
	}

	handleOpen = () => this.setState({ isOpen: true });
	handleClose = () => {
		this.setState({
			isOpen: false,
			isLoading: false,
		});

		this.props.onModalClosed(this.props.id);
	}
}


export default OverlayConfirmProvider;
